export const MainConfig = {
    AppDetails: {
        app_name: "BipBip On demand delivery", 
        app_description: "BipBip smart delivery services",
        app_identifier: "com.totalx.delivery",
        ios_app_version: "3.3.7", 
        android_app_version: 12
    },

    FirebaseConfig: {
        apiKey: "AIzaSyCzsyhF3JXlAQTIlHptcXOJFpAnRVMEkHk",
        authDomain: "totalx-58f2e.firebaseapp.com",
        databaseURL: "https://totalx-58f2e-default-rtdb.firebaseio.com",
        projectId: "totalx-58f2e",
        storageBucket: "totalx-58f2e.appspot.com",
        messagingSenderId: "230783082679",
        appId: "1:230783082679:web:c96a6d26cb9b86bc12ed32"
    },

    Google_Map_API_Key: {
        ios: "AIzaSyDVIohMWize9U5A33EYce1I2mbuTPu9HVQ",
        android: "AIzaSyC-uMMI_ucxF5Rn6mZ9QsRHNyCcGHEbQ7c",
        web: "AIzaSyBMCU0ZX_fZ-LHS9-tZ6gFqTJYMzgvTixA"
    }   
}